import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { ConfirmEmailContainer } from '../../modules/auth/containers/ConfirmEmailContainer';

export const ConfirmEmailView = (): ReactElement => (
  <AuthContainer>
    <ConfirmEmailContainer />
  </AuthContainer>
);
